import app from 'app';
import templateUrl from './submitClaimBillUpload.html';
import './submitClaimBillUpload.scss';
import './fileList/fileList';
import './fileUploader/fileUploader';
import './submitClaimBillUploadConstants';
import './submitClaimBillUploadService';

import { logEvent, eventCategories } from 'helpers/analytics';

import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-exclamation';

function SubmitClaimBillUpload(SubmitClaimBillUploadConstants) {
  const SubmitClaimBillUpload = this;

  // Maximum number of files allowed to be uploaded
  SubmitClaimBillUpload.maxFiles = 10;

  // Don't allow files over 10mb
  SubmitClaimBillUpload.maxFileSize = 10000000;

  SubmitClaimBillUpload.back = function() {
    SubmitClaimBillUpload.page = 'verify_bill';
  };

  SubmitClaimBillUpload.next = function() {
    logEvent('MSOONFlowCompleted', {
      category: eventCategories.MSOON
    });
    SubmitClaimBillUpload.page = 'review';
  };

  function hasFilesNotUploaded() {
    return (
      SubmitClaimBillUpload.files.filter(
        x => x.status !== SubmitClaimBillUploadConstants.status.UPLOADED
      ).length > 0
    );
  }

  SubmitClaimBillUpload.notReadyToUpload = function() {
    return (
      !SubmitClaimBillUpload.files ||
      SubmitClaimBillUpload.files.length === 0 ||
      hasFilesNotUploaded()
    );
  };
}

app.component('submitClaimBillUpload', {
  bindings: {
    files: '=',
    page: '='
  },
  controller: SubmitClaimBillUpload,
  controllerAs: 'SubmitClaimBillUpload',
  templateUrl
});

export default 'submitClaimBillUpload';
